import { Button } from '@/components/Button';
import { ContactBox } from '@/components/ContactBox';
import { DisplayComponent } from '@/components/DisplayComponent';
import { Header } from '@/components/Header';
import { RemoteImage } from '@/components/RemoteImage';
import { ELoanUsage, setLoanUsage, setPaidAmount } from '@/context/borrower';
import { EDisplays, setDisplay } from '@/context/display';
import { useAppDispatch } from '@/context/storeHooks';

const baseId = 'screen-EmploymentIneligible';

export function EmploymentIneligible(): JSX.Element {
    // ***** Redux State *****
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChangeLoanUsage(): void {
        dispatch(setPaidAmount(undefined));
        dispatch(setLoanUsage(ELoanUsage.PERSONAL));
        dispatch(setDisplay(EDisplays.QUICK_CALCULATOR));
    }

    return (
        <DisplayComponent baseId={baseId} data-testid={baseId}>
            <Header />
            <div className='flex-center pb-4 relative'>
                <div className='bg-primary h-40 w-40 rounded-full' />
                <RemoteImage fileName='coins.svg' className='absolute' />
            </div>
            <div className='max-w-lg mx-auto p-4 flex flex-col space-y-4 text-center'>
                <h3 className='uppercase text-xl text-primary font-bold'>
                    It looks like your employment status doesn’t qualify for a
                    novated lease.
                </h3>
                <p className='text-secondary text-center'>
                    Novated leases require you to be:
                </p>
                <ul className='list-disc list-inside text-secondary ml-6 text-left'>
                    <li>A full-time or part-time employee.</li>
                    <li>Receiving a consistent salary.</li>
                    <li>
                        Working for an employer who{' '}
                        <span className='px-6'>offers salary packaging.</span>
                    </li>
                </ul>

                <p className='text-secondary ml-6 text-left'>
                    If you’re on a casual contract, self-employed, or your
                    employer doesn’t provide salary packaging, this option may
                    not be available.
                </p>
                <p className='text-sm ml-6 text-left'>
                    Still have questions? Contact us to discuss alternative
                    financing options.
                </p>
            </div>

            <div className='flex space-x-2 mx-4 pt-4'>
                <Button
                    id={`${baseId}-button-reduceLoan`}
                    onClick={handleChangeLoanUsage}
                >
                    Change Loan to Consumer
                </Button>
            </div>

            <div className='flex-center w-full'>
                <ContactBox />
            </div>
        </DisplayComponent>
    );
}
